// Google Analytics service
export const GA_TRACKING_ID = 'G-32K44X8XDQ';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('click', 'button', `${buttonName}_${location}`);
};

// Track navigation
export const trackNavigation = (from, to) => {
  trackEvent('navigation', 'page', `${from}_to_${to}`);
};

// Track user interactions
export const trackUserInteraction = (interaction, details) => {
  trackEvent('user_interaction', interaction, details);
};

// Track token interactions
export const trackTokenInteraction = (action, tokenName) => {
  trackEvent('token_interaction', action, tokenName);
};

// Track 3D scene interactions
export const trackSceneInteraction = (scene, action) => {
  trackEvent('scene_interaction', scene, action);
};
